import Select from "../../gui/Select/Select";
import Tabs, { TMenuRow } from "../../gui/Tabs/Tabs";
import { usePath } from "../../libs/path/PathProvider";

const Routes : TMenuRow<string>[] = [
    {text:"Home",id:"/home",url:"/home"},
    {text:"Summary",id:"/summary",url:"/summary"},
    {text:"Fixed",id:"/fixed",url:"/fixed"},
    {text:"Dividends",id:"/dividends",url:"/dividends"},
    {text:"D.History",id:"/divhist",url:"/dhistory"},
    {text:"Calendar",id:"/calendar",url:"/calendar"},
    {text:"Sectors",id:"/sector",url:"/sector"},
    {text:"Tax",id:"/tax",url:"/tax"},
    {text:"History",id:"/history",url:"/history"},
    {text:"Config",id:"/config",url:"/config"},
]

export default function MainTabs(){
    const {path} = usePath();
    return <header className="flex middle gap-8">
        <Tabs preIcon={<div className="logo"/>} options={Routes} breakpoint={-1} defaultValue={path}/>
    </header>
}